export default [
    {
        path: '/muhasebe-genel',
        name: 'muhasebe-genel', 
        meta: { resource: 'admin' },
        component: () => import('../views/accountant/genel')
    },
    {
        path: '/muhasebe-sahsi',
        name: 'muhasebe-sahsi',
        meta: { resource: 'admin|dealer'},
        component: () => import('../views/accountant/sahsi')
    },
    {
        path: '/fatura-makbuz-ara',
        name: 'fatura-makbuz-ara',
        meta: { resource: 'admin'},
        component: () => import('../views/accountant/ara')
    },
]
  